import React from 'react';
import Header from './components/Header';
import * as Images from '../assets';
import { Grid } from '@mui/material';
import { LightBlueButton } from '../components';
import { Link } from 'react-router-dom';
import { routesName } from '../constants/routes-name';

const NgounStaff = () => {
  return (
    <div>
      {/* <Header page="ngoun-staff" /> */}
      <div
        className="md:px-8 px-2 md:py-6 py-4"
        style={{
          backgroundImage: `url('${Images.homePage8}')`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          transition:
            'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s',
        }}
      >
        <div className="flex justify-center">
          <div className="lg:w-[80%] md:w-[85%] sm:w-[95%] w-[100%] ">
            <div className="md:px-16 md:py-16 px-6 py-10 ">
              <div className="flex flex-col gap-12 items-center ">
                <div className="flex flex-col gap-2 items-center">
                  <div className="text-[var(--blue)] font-bold text-md text-center uppercase tracking-[3px] mb-6">
                    PUBLISH TENDER UN/NGO Staff
                  </div>

                  <div className="text-[var(--blue)] font-bold text-md uppercase tracking-[3px]">
                    Good for everyone
                  </div>
                  <div className="divider-light" />
                </div>
                <div>
                  <div className="lg:text-6xl md:text-4xl text-2xl font-bold text-center">
                    FREE for Humanitarian Organisations
                  </div>
                  <div className="font-semibold text-center text-lg">
                    to publish their tenders on our notice board
                  </div>
                </div>
                <div className="text-md text-center leading-[2] md:px-28 px-8 ">
                  Everyone Benefits. Aid-LINK believes that Free is good for
                  everyone. By being open and freely available for the
                  humanitarian actors, it enables and encourages suppliers to
                  access and engage in bidding, ensuring organisation a variety
                  and qualified numbers of bids. <br />
                  Helping humanitarian organisations solve real world problems!
                </div>
                <div className="text-md text-center leading-[2] md:px-28 px-8 ">
                  If you represent a non-profit organisation, NGO, INGO, UN
                  agency or an educational institution, your organisation will
                  be able to publish tenders for FREE on our platform.
                </div>
                <div className="text-md text-center leading-[2] md:px-28 px-8 ">
                  Simply register and start publishing for free.
                </div>
                <div className="flex gap-2 flex-wrap">
                  <Link to={routesName.pricing}>
                    <LightBlueButton size="large">Get started</LightBlueButton>
                  </Link>
                  <Link to={routesName.contact}>
                    <LightBlueButton size="large">Learn more</LightBlueButton>
                  </Link>
                  {/* <LightBlueButton size="large">Register Free</LightBlueButton> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NgounStaff;
